import axios from "axios";

//const API_BASE_URL = process.env.REACT_APP_API_URL;
 const API_BASE_URL = process.env.REACT_APP_API_URL
 

const apiRequest = async (method, url, data = null, config = {}) => {
  try {
    console.log("p", `${API_BASE_URL}${url}`);
    const response = await axios({
      method: method,
      url: `${API_BASE_URL}${url}`,
      data: data,
      ...config,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error during ${method.toUpperCase()} request to ${url}:`,
      error
    );
    throw error;
  }
};

// Wrapper methods for common HTTP methods
export const get = (url, config = {}) => apiRequest("get", url, null, config);
export const post = (url, data, config = {}) =>
  apiRequest("post", url, data, config);
export const put = (url, data, config = {}) =>
  apiRequest("put", url, data, config);
export const del = (url, data = null, config = {}) =>
  apiRequest("delete", url, data, { data, ...config });
